/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';

/**
 * This component is the user's token modal form.
 *
 * @category ui.pages.profile.user-profile
 * @exports UserToken
 * @component
 */
const __vue_script__ = {
    name: 'UserToken',

    components: { BaseInput },

    data() {
        return {
            label: null,
            token: null,
            error: null
        };
    },

    methods: {
        /**
         * Creates the token
         */
        async create() {
            const valid = await this.$refs.form.validate();

            if (!valid) { return; }

            try {
                const { token } = await this.$services.oidc.getToken(this.label);

                this.token = token;

            } catch (error) {
                this.error = error.message;
            }
        },

        /**
         * Alerts the user that the token has been copied into the clipboard
         */
        onCopy() {
            this.$notify({
                group: 'flashes',
                text: this.$i18n.t('profile.tokens.token.copied').toString(),
                type: 'success'
            });
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-token"},[(!_vm.token && !_vm.error)?_c('validation-observer',{ref:"form",staticClass:"user-token-form modal-wrapper",attrs:{"tag":"form","autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return _vm.create()}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var invalid = ref.invalid;
return [_c('div',{staticClass:"modal-header"},[_c('span',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}}),_c('h2',[_vm._v(_vm._s(_vm.$t('profile.tokens.form.title')))])]),_c('div',{staticClass:"modal-body"},[_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":_vm.$t('profile.tokens.form.name')},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"label":_vm.$t('profile.tokens.form.name'),"type":"text","name":"name","errors":errors,"placeholder":_vm.$t('profile.tokens.form.name_placeholder')},model:{value:(_vm.label),callback:function ($$v) {_vm.label=$$v},expression:"label"}})]}}],null,true)})],1),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"submit"}},[_vm._v(_vm._s(_vm.$t('profile.tokens.form.submit')))])])]}}],null,false,4199142935)}):_vm._e(),(_vm.token && !_vm.error)?_c('div',{staticClass:"token-created modal-wrapper"},[_c('div',{staticClass:"modal-header"},[_c('span',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}}),_c('h2',[_vm._v(_vm._s(_vm.$t('profile.tokens.token.title')))])]),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"alert alert-warning"},[_vm._v(_vm._s(_vm.$t('profile.tokens.token.alert')))]),_c('div',{staticClass:"token-sid"},[_c('textarea',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.token),expression:"token",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.onCopy),expression:"onCopy",arg:"success"},{name:"tooltip",rawName:"v-tooltip",value:(_vm.$t('profile.tokens.token.hint')),expression:"$t('profile.tokens.token.hint')"}],staticClass:"form-control",attrs:{"rows":"8","readonly":"readonly"}},[_vm._v(_vm._s(_vm.token))])])]),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(_vm._s(_vm.$t('general.dismiss')))])])]):_vm._e(),(_vm.error)?_c('div',{staticClass:"token-error modal-wrapper"},[_c('div',{staticClass:"modal-header"},[_c('span',{staticClass:"close",on:{"click":function($event){return _vm.$emit('close')}}}),_c('h2',[_vm._v(_vm._s(_vm.$t('general.error_occurred')))])]),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"alert alert-error"},[_vm._v(_vm._s(_vm.error))])]),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(_vm._s(_vm.$t('general.dismiss')))])])]):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "UserToken.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__